import React, { useState, useEffect, useMemo, useRef } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import SweetAlert from "react-bootstrap-sweetalert";
import redirectURL from "../redirectURL";
import "./overviewdashboard.css";
import "./datepicker.css"
import CountUp from "react-countup";
import { FaInfoCircle } from "react-icons/fa";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { MultiSelect } from 'primereact/multiselect';
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import { WiCloudRefresh } from "react-icons/wi";

import { 
  FaExclamationTriangle,
  FaExclamationCircle,
  FaCheckCircle,
  FaBoxOpen,
  FaChartLine,
  FaBalanceScale,
  FaMoneyBillWave,
  FaSync,
  FaDownload,
  FaMapMarkerAlt,FileText,
  FaChevronDown,
  FaCalendarAlt,
  FaFilter,
  FaExclamation,
  FaPercent,
  FaBan,
  FaTimesCircle
} from "react-icons/fa";

const OverviewDashboard = () => {
  const [loadshow, setLoadshow] = useState("show-n");
  const [overlayBlock, setOverlayBlock] = useState("show-n");
  const [show, setShow] = useState(false);
  const [basicTitle, setBasicTitle] = useState("");
  const [basicType, setBasicType] = useState("default");

  const [rowData, setRowData] = useState([]);
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [locationOptions, setLocationOptions] = useState([]);
  const [locationNames, setLocationNames] = useState({});
  const [categoryOptions, setCategoryOptions] = useState([]);
  const [apiData, setApiData] = useState(null);
  const [activeCategory, setActiveCategory] = useState("total");
  const [highlightedDates, setHighlightedDates] = useState([]);
  const [hasAnimated, setHasAnimated] = useState(false);
  
  const isApplyDisabled = selectedLocations.length === 0 || selectedCategories.length === 0;

  const datePickerRef = useRef(null);
  
  const CustomHeader = (props) => {
    const tooltip = props?.column?.getColDef()?.headerTooltip || "";
    const [showMenu, setShowMenu] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    const onMenuClick = (event) => {
      props.showColumnMenu(event.currentTarget);
    };

    const onSortRequested = (order, event) => {
      props.setSort(order, event?.shiftKey);
    };

    const getSort = () => {
      return props.column.getSort();
    };

    const isSortable = props.column.getColDef().sortable;

    return (
      <div
        style={{ display: "flex", alignItems: "center", gap: 6, position: "relative" }}
        onMouseEnter={() => setShowMenu(true)}
        onMouseLeave={() => setShowMenu(false)}
      >
        <span
          style={{
            cursor: isSortable ? "pointer" : "default",
            userSelect: "none"
          }}
          onClick={isSortable ? () => {
            const currentSort = getSort();
            let newSort = 'asc';
            if (currentSort === 'asc') newSort = 'desc';
            else if (currentSort === 'desc') newSort = null;
            onSortRequested(newSort, null);
          } : undefined}
        >
          {props.displayName}
        </span>

        {isSortable && (
          <div style={{ display: "flex", flexDirection: "column", marginRight: 2 }}>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'asc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('asc', null)}
            >
              ↑
            </span>
            <span
              style={{
                cursor: "pointer",
                fontSize: 10,
                opacity: getSort() === 'desc' ? 1 : 0.3,
                lineHeight: "8px"
              }}
              onClick={() => onSortRequested('desc', null)}
            >
              ↓
            </span>
          </div>
        )}

        <div
          style={{ position: "relative", display: "inline-block" }}
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
        >
          <FaInfoCircle style={{ fontSize: 18, opacity: 0.7 }} />

          {showTooltip && tooltip && (
            <div
              style={{
                position: "absolute",
                top: "100%",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "white",
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "12px",
                whiteSpace: "nowrap",
                zIndex: 1000,
                marginTop: "5px",
              }}
            >
              {tooltip}
            </div>
          )}
        </div>

        {props.enableMenu && (
          <span
            onClick={onMenuClick}
            style={{
              marginLeft: "5px",
              cursor: "pointer",
              fontSize: 14,
              opacity: showMenu ? 1 : 0,
              transition: "opacity 0.2s ease",
            }}
          >
            ☰
          </span>
        )}
      </div>
    );
  };

  const [docStats, setDocStats] = useState({
    critical: { 
      count: 0, 
      label: "Critical", 
      range: "0-7 Days DOC", 
      description: "Immediate action needed", 
      icon: <FaExclamationTriangle />, 
      color: "#dc3545" 
    },
    warning: { 
      count: 0, 
      label: "Warning", 
      range: "8-14 Days DOC", 
      description: "Monitor closely", 
      icon: <FaExclamationCircle />, 
      color: "#ff9800" 
    },
    healthy: { 
      count: 0, 
      label: "Healthy", 
      range: "15-60 Days DOC", 
      description: "No action required", 
      icon: <FaCheckCircle />, 
      color: "#28a745" 
    },
    overstock: { 
      count: 0, 
      label: "Overstock", 
      range: ">60 Days DOC", 
      description: "Potential waste risk", 
      icon: <FaBoxOpen />, 
      color: "#6f42c1" 
    }
  });

  const columnDefs = useMemo(() => ({
    critical: [
      { 
        field: "destination_store_name", 
        headerName: "Destination Name", 
        width: 180 
      },
      { 
        field: "destination_store_id", 
        headerName: "Destination ID ", 
        width: 180 
      },
      { 
        field: "sku_code", 
        headerName: "SKU Code", 
        width: 120, 
        filter: true 
      },
      { 
        field: "sku_name", 
        headerName: "SKU Name", 
        width: 180, 
        filter: true 
      },
      { 
        field: "sku_category", 
        headerName: "Category", 
        width: 150, 
        filter: true 
      },
      { 
        field: "current_stock", 
        headerName: "Current Stock", 
        width: 120 
      },
      { 
        field: "avg_rr", 
        headerName: "Avg Run Rate", 
        width: 120 
      },
      { 
        field: "days_of_cover", 
        headerName: "DOC", 
        width: 100
      }
    ],
    warning: [
      { 
        field: "destination_store_name", 
        headerName: "Destination Name", 
        width: 180 
      },
      { 
        field: "destination_store_id", 
        headerName: "Destination ID ", 
        width: 180 
      },
      { 
        field: "sku_code", 
        headerName: "SKU Code", 
        width: 120, 
        filter: true 
      },
      { 
        field: "sku_name", 
        headerName: "SKU Name", 
        width: 180, 
        filter: true 
      },
      { 
        field: "sku_category", 
        headerName: "Category", 
        width: 150, 
        filter: true 
      },
      { 
        field: "current_stock", 
        headerName: "Current Stock", 
        width: 120 
      },
      { 
        field: "avg_rr", 
        headerName: "Avg Run Rate", 
        width: 120 
      },
      { 
        field: "days_of_cover", 
        headerName: "DOC", 
        width: 100
      }
    ],
    healthy: [
      { 
        field: "destination_store_name", 
        headerName: "Destination Name", 
        width: 180 
      },
      { 
        field: "destination_store_id", 
        headerName: "Destination ID ", 
        width: 180 
      },
      { 
        field: "sku_code", 
        headerName: "SKU Code", 
        width: 120, 
        filter: true 
      },
      { 
        field: "sku_name", 
        headerName: "SKU Name", 
        width: 180, 
        filter: true 
      },
      { 
        field: "sku_category", 
        headerName: "Category", 
        width: 150, 
        filter: true 
      },
      { 
        field: "current_stock", 
        headerName: "Current Stock", 
        width: 120 
      },
      { 
        field: "avg_rr", 
        headerName: "Avg Run Rate", 
        width: 120 
      },
      { 
        field: "days_of_cover", 
        headerName: "DOC", 
        width: 100
      }
    ],
    overstock: [
      { 
        field: "destination_store_name", 
        headerName: "Destination Name", 
        width: 180 
      },
      { 
        field: "destination_store_id", 
        headerName: "Destination ID ", 
        width: 180 
      },
      { 
        field: "sku_code", 
        headerName: "SKU Code", 
        width: 120, 
        filter: true 
      },
      { 
        field: "sku_name", 
        headerName: "SKU Name", 
        width: 180, 
        filter: true 
      },
      { 
        field: "sku_category", 
        headerName: "Category", 
        width: 150, 
        filter: true 
      },
      { 
        field: "current_stock", 
        headerName: "Current Stock", 
        width: 120 
      },
      { 
        field: "avg_rr", 
        headerName: "Avg Run Rate", 
        width: 120 
      },
      { 
        field: "days_of_cover", 
        headerName: "DOC", 
        width: 100
      }
    ],
    potentialRisk: [
      { 
        field: "destination_store_id", 
        headerName: "Destination ID", 
        width: 100 
      },
      { 
        field: "destination_store_name", 
        headerName: "Destination Name", 
        width: 180 
      },
      { 
        field: "destination_type", 
        headerName: "Destination Type", 
        width: 120 
      },
      { 
        field: "sku_code", 
        headerName: "SKU Code", 
        width: 120 
      },
      { 
        field: "sku_name", 
        headerName: "SKU Name", 
        width: 200 
      },
      { 
        field: "sku_category", 
        headerName: "Category", 
        width: 150 
      },
      { 
        field: "potential_risk", 
        headerName: "Risk Qty", 
        width: 110
      },
      { 
        field: "avg_rr", 
        headerName: "Avg Run Rate", 
        width: 110
      },
      { 
        field: "product_type", 
        headerName: "Product Type",   
        minWidth: 200,
      },
      { 
        field: "unit_cost", 
        headerName: "Unit Cost (₹)", 
        width: 100,
        valueGetter: (params) => params.data?.unit_cost 
      },
      { 
        field: "gmv", 
        headerName: "GMV (₹)", 
        width: 130,
        valueGetter: (params) => params.data?.gmv,
        headerTooltip: "Risk Qty * Unit Cost",
        headerComponent: CustomHeader,
      }
    ],
    nonFresh: [
      { 
        field: "destination_store_id", 
        headerName: "Destination ID", 
        width: 100 
      },
      { 
        field: "destination_store_name", 
        headerName: "Destination Name", 
        width: 180 
      },
      { 
        field: "destination_type", 
        headerName: "Destination Type", 
        minWidth: 150 
      },
      { 
        field: "sku_code", 
        headerName: "SKU Code", 
        width: 120 
      },
      { 
        field: "sku_name", 
        headerName: "SKU Name", 
        width: 200 
      },
      { 
        field: "sku_category", 
        headerName: "Category", 
        width: 150 
      },
      { 
        field: "stock", 
        headerName: "Stock", 
        width: 120 
      },
        { 
        field: "gmv", 
        headerName: "GMV(₹)", 
        width: 120 
      },  { 
        field: "unit_cost", 
        headerName: "Unit Cost", 
        width: 120 
      },
      { 
        field: "for", 
        headerName: "For", 
        width: 120 
      },
      { 
        field: "check", 
        headerName: "Check", 
        width: 150 
      },
    ],
    total: [
      { 
        field: "destination_store_name", 
        headerName: "Destination Name", 
        width: 180 
      },
      { 
        field: "destination_store_id", 
        headerName: "Destination ID ", 
        width: 180 
      },
      { 
        field: "sku_code", 
        headerName: "SKU Code", 
        width: 120, 
        filter: true 
      },
      { 
        field: "sku_name", 
        headerName: "SKU Name", 
        width: 180, 
        filter: true 
      },
      { 
        field: "sku_category", 
        headerName: "Category", 
        width: 150, 
        filter: true 
      },
      { 
        field: "current_stock", 
        headerName: "Current Stock", 
        width: 120 
      },
      { 
        field: "avg_rr", 
        headerName: "Avg Run Rate", 
        width: 120 
      },
      { 
        field: "days_of_cover", 
        headerName: "DOC", 
        width: 100
      },
      { 
        field: "status", 
        headerName: "Status", 
        width: 120,
        cellStyle: (params) => {
          const status = params.data?.status;
          if (status === 'critical') return { color: '#dc3545', fontWeight: 'bold' };
          if (status === 'warning') return { color: '#ff9800', fontWeight: 'bold' };
          if (status === 'healthy') return { color: '#28a745', fontWeight: 'bold' };
          if (status === 'overstock') return { color: '#6f42c1', fontWeight: 'bold' };
          return {};
        }
      }
    ]
  }), []);

  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      resizable: true,
      flex: 1,
      minWidth: 100,
      cellStyle: { fontSize: '13px' }
    }),
    []
  );

  const getHighlightedDates = async () => {  
    try {
      const response = await redirectURL.post("inventory/getdarkstoredates", {});
      if (response.status === 200 && response.data.dates) {
        const dates = response.data.dates.map(dateStr => {
          try {
            return new Date(dateStr);
          } catch (e) {
            return null;
          }
        }).filter(date => date !== null);
        setHighlightedDates(dates);
      }
    } catch (error) {
      console.error("Failed to fetch highlighted dates:", error);
    }
  }

  const fetchLocationOptions = async () => {
    try {
      const resp = await redirectURL.post("inventory/getlocationData");
      
      if (resp && resp.data && resp.data.status === "success") {
        const locations = resp.data.data || [];

        const darkStores = locations.filter(location => 
          (location.is_active === 1 || location.is_active === 0) && 
          location.destination_store_id !== "MWH01"
        );
        
        darkStores.sort((a, b) => a.destination_store_id.localeCompare(b.destination_store_id));
        
        const locationOptionsArr = darkStores.map(loc => ({
          label: `${loc.destination_store_id} - ${loc.destination_store_name}`,
          value: loc.destination_store_id
        }));
        
        const locationNamesMapping = {};
        darkStores.forEach(loc => {
          locationNamesMapping[loc.destination_store_id] = `${loc.destination_store_id} - ${loc.destination_store_name}`;
        });
        
        setLocationOptions(locationOptionsArr);
        setLocationNames(locationNamesMapping);
        
        if (locationOptionsArr.length > 0) {
          const allLocationValues = locationOptionsArr.map(option => option.value);
          setSelectedLocations(allLocationValues);
        }
        
        await getHighlightedDates();
      } else {
        console.error("Failed to fetch location options");
        const defaultLocations = [{
          label: "D007 - Bangalore DS 1",
          value: "D007"
        }];
        setLocationOptions(defaultLocations);
        setLocationNames({
          "D007": "D007 - Bangalore DS 1",
        });
        setSelectedLocations(["D007"]);
      }
    } catch (error) {
      console.error("Error fetching location options:", error);
      const defaultLocations = [{
        label: "D007 - Bangalore DS 1",
        value: "D007"
      }];
      setLocationOptions(defaultLocations);
      setLocationNames({
        "D007": "D007 - Bangalore DS 1",
      });
      setSelectedLocations(["D007"]);
    }
  };

  const fetchCategoryOptions = async () => {
    try {
      const resp = await redirectURL.post("inventory/getSKUCategories");
      
      if (resp && resp.data && resp.data.status === "success") {
        const categories = resp.data.categories || [];
        
        const categoryOptionsArr = categories.map(cat => ({
          label: cat,
          value: cat
        }));
        
        setCategoryOptions(categoryOptionsArr);
        
        if (categories.length > 0) {
          const allCategoryValues = categories;
          setSelectedCategories(allCategoryValues);
        }
        
      } else {
        console.error("Failed to fetch category options");
        setCategoryOptions([]);
        setSelectedCategories([]);
      }
    } catch (error) {
      console.error("Error fetching category options:", error);
      setCategoryOptions([]);
      setSelectedCategories([]);
    }
  };

  const fetchDashboardData = async () => {
    setLoadshow("show-m");
    setOverlayBlock("show-m");
    
    try {
      setHasAnimated(false);
      
      const formattedDate = selectedDate ? selectedDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
      
      const payload = { 
        date: formattedDate,
        location: selectedLocations,
        category: selectedCategories 
      };
      
      const resp = await redirectURL.post("inventory/InventoryOverview", payload);    
      
      if (resp && resp.data) {
        if (resp.data.status === "Success") {
          const data = resp.data.data || {};
          setApiData(data);
          
          // Update DOC statistics
          setDocStats(prev => ({
            ...prev,
            critical: { ...prev.critical, count: data.critical_skus_count || 0 },
            warning: { ...prev.warning, count: data.warning_skus_count || 0 },
            healthy: { ...prev.healthy, count: data.healthy_skus_count || 0 },
            overstock: { ...prev.overstock, count: data.overstock_skus_count || 0 }
          }));
          
          // Set initial data to total SKUs
          setRowData(data.total_skus_data || []);
          
          // Clear any error message on success
          setBasicTitle("");
          setShow(false);
          
        } else if (resp.data.status === "Failure") {
          setBasicTitle(resp.data.message || "Failed to fetch inventory data");
          setBasicType("error");
          setShow(true);

          setApiData(null);
          setRowData([]);
          setActiveCategory("total");

          // Reset DOC stats
          setDocStats(prev => ({
            ...prev,
            critical: { ...prev.critical, count: 0 },
            warning: { ...prev.warning, count: 0 },
            healthy: { ...prev.healthy, count: 0 },
            overstock: { ...prev.overstock, count: 0 }
          }));
        } else {
          setBasicTitle("Invalid response from server");
          setBasicType("error");
          setShow(true);
        }
      } else {
        setBasicTitle("No response from server");
        setBasicType("error");
        setShow(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setBasicTitle(error.response?.data?.message || error.message || "Failed to fetch inventory overview data");
      setBasicType("error");
      setShow(true);
    } finally {
      setTimeout(() => {
        setLoadshow("show-n");
        setOverlayBlock("show-n");
        setHasAnimated(true);
      }, 500);
    }
  };
  
  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    
    if (!apiData) return;
    
    switch (category) {
      case "critical":
        setRowData(apiData.critical_skus_data || []);
        break;
      case "warning":
        setRowData(apiData.warning_skus_data || []);
        break;
      case "healthy":
        setRowData(apiData.healthy_skus_data || []);
        break;
      case "overstock":
        setRowData(apiData.overstock_skus_data || []);
        break;
      case "potentialRisk":
        setRowData(apiData.potential_risk_data || []);
        break;
      case "nonFresh":
        setRowData(apiData.non_fresh_data || []);
        break;
      default:
        setRowData(apiData.total_skus_data || []);
    }
  };

  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
    } else {
      setSelectedDate(new Date());
    }
  };

  const handleExport = () => {
    if (window.gridApi) {
      const formattedDate = selectedDate ? selectedDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
      const locationLabel = selectedLocations.length === locationOptions.length ? "All" : selectedLocations.join("_");
      const categoryLabel = selectedCategories.length === categoryOptions.length ? "All" : selectedCategories.join("_");
      const params = {
        fileName: `inventory_overview_${locationLabel}_${formattedDate}_${categoryLabel}.csv`
      };
      window.gridApi.exportDataAsCsv(params);
    }
  };

  const handleApply = () => {
    setActiveCategory("total");
    fetchDashboardData();
  };

  const onGridReady = (params) => {
    window.gridApi = params.api;
    params.api.sizeColumnsToFit();
  };
  
  const sideBar = useMemo(() => ({
    toolPanels: [
      {
        id: "columns",
        labelDefault: "Columns",
        labelKey: "columns",
        iconKey: "columns",
        toolPanel: "agColumnsToolPanel",
      },
      {
        id: "filters",
        labelDefault: "Filters",
        labelKey: "filters",
        iconKey: "filter",
        toolPanel: "agFiltersToolPanel",
      },
    ]
  }), []);
  
  const statusPanel = {
    statusPanels: [
      {
        statusPanel: "agTotalAndFilteredRowCountComponent",
        align: "left"
      },
      {
        statusPanel: "agTotalRowCountComponent",
        align: "center"
      },
      { statusPanel: "agFilteredRowCountComponent" },
      { statusPanel: "agSelectedRowCountComponent" },
      { statusPanel: "agAggregationComponent" }
    ]
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showDatePicker && datePickerRef.current && !datePickerRef.current.contains(event.target)) {
        setShowDatePicker(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [showDatePicker]);

  useEffect(() => {
    fetchLocationOptions();
    fetchCategoryOptions();
  }, []);

  useEffect(() => {
    if (locationOptions.length > 0 && categoryOptions.length > 0) {
      fetchDashboardData();
    }
  }, [locationOptions, categoryOptions]);

  const getTotalSKUs = () => {
    const data = apiData || {};
    return (data.critical_skus_count || 0) + 
           (data.warning_skus_count || 0) + 
           (data.healthy_skus_count || 0) + 
           (data.overstock_skus_count || 0) || 0;
  };

  const formatNumber = (num) => {
    if (typeof num !== 'number') return '0';
    return num.toLocaleString('en-IN');
  };

  const formatDisplayDate = (date) => {
    if (!date) return new Date().toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
    
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  // Function to get potential risk data from API
  const getPotentialRiskData = () => {
    const data = apiData || {};
    return {
      riskQty: data.total_potential_risk_qty || 0,
      gmvAtRisk: data.total_potential_risk_gmv || 0,
      rtoStock: data.rto_total_stock || 0,
      nonInvStock: data.rto_non_inv_total_stock || 0,

        // ✅ new counts
    rtoTotalGmv: data.rto_total_gmv || 0,
    nonInvTotalGMV: data.rto_non_inv_total_gmv || 0,
    };
  };

  // Function to get non-fresh data from API
  const getNonFreshData = () => {
    const data = apiData || {};
    return {
      // nonFreshSKUs: data.non_fresh_sku_count || 0,
      // nonInvoiceableSKUs: data.non_invoiceable_sku_count || 0,

      nonFreshGmv: data.non_fresh_total_gmv || 0,
      nonInvoiceableGmv: data.non_invoiceable_total_gmv || 0,
      
      nonFreshStock: data.non_fresh_total_stock || 0,
      nonInvoiceableStock: data.non_invoiceable_total_stock || 0
    };
  };

  return (
    <>
      <div className="dashboard-container">
        <div style={{ zIndex: "9999999" }}>
          <SweetAlert
            show={show}
            type={basicType}
            title={basicTitle}
            onConfirm={() => setShow(false)}
          />
        </div>
        
        {/* Dashboard Header */}
        <div className="dashboard-header">
          <div className="header-left">
            <h1 className="dashboard-title">Inventory Overview Dashboard</h1>
            <p className="header-left">Days of Coverage (DOC) & Inventory Analysis</p>
          </div>

          <div className="header-right">
            {/* Destination Store - MultiSelect */}
            <div className="filter-container multi-select-container">
              <div className="filter-title">Destination Store :</div>
              <div className="multi-select-wrapper">
                <MultiSelect
                  value={selectedLocations}
                  options={locationOptions}
                  onChange={(e) => setSelectedLocations(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  filter
                  maxSelectedLabels={1}
                  display="chip"
                  placeholder="Select destinations"
                  style={{
                    width: "100%",
                    borderRadius: "5px",
                    backgroundColor: "#fff",
                    fontSize: "13px",
                  }}
                />
              </div>
            </div>

            {/* Category - MultiSelect */}
            <div className="filter-container multi-select-container">
              <div className="filter-title">Category :</div>
              <div className="multi-select-wrapper">
                <MultiSelect
                  value={selectedCategories}
                  options={categoryOptions}
                  onChange={(e) => setSelectedCategories(e.value)}
                  optionLabel="label"
                  optionValue="value"
                  filter
                  maxSelectedLabels={1}
                  display="chip"
                  placeholder="Select categories"
                  style={{
                    width: "100%",
                    borderRadius: "5px",
                    backgroundColor: "#fff",
                    fontSize: "13px",
                  }}
                />
              </div>
            </div>

            {/* Date */}
            <div className="filter-container datepicker-container" ref={datePickerRef}>
              <div className="filter-title">Date :</div>
              <DatePicker
                selected={selectedDate}
                onChange={handleDateChange}
                highlightDates={highlightedDates}
                dateFormat="yyyy-MM-dd"
                maxDate={new Date()}
                wrapperClassName="date-picker-wrapper"
                customInput={
                  <div className="filter-select datepicker-input">
                    <FaCalendarAlt className="filter-icon" />
                    <span className="filter-label">
                      {formatDisplayDate(selectedDate)}
                    </span>
                  </div>
                }
              />
            </div>

            {/* Apply */}
            <button
              className="btn-refresh"
              onClick={handleApply}
              disabled={isApplyDisabled}
              style={{
                cursor: isApplyDisabled ? "not-allowed" : "pointer",
                opacity: isApplyDisabled ? 0.6 : 1
              }}
            >
              Apply
            </button>
          </div>
        </div>

        {/* 5 Counters Grid */}
        <div className="overview-container-doc-stats">
          
          {/* 1️⃣ Total SKUs */}
          <div
            className={`doc-stat-card ${activeCategory === "total" ? "active" : ""}`}
            onClick={() => handleCategoryClick("total")}
            style={{ cursor: "pointer" }}
          >
            <div className="doc-stat-icon" style={{ color: "#007bff" }}>
              <FaBoxOpen />
            </div>
            <div className="doc-stat-content">
              <div className="doc-stat-count">
                {hasAnimated ? (
                  <span>{formatNumber(getTotalSKUs())}</span>
                ) : (
                  <CountUp start={0} end={getTotalSKUs()} duration={1} />
                )}
              </div>
              <div className="doc-stat-label">Total SKUs</div>
              <div className="doc-stat-range">All Categories</div>
              <div className="doc-stat-description">Complete inventory overview</div>
            </div>
          </div>

          {/* 2️⃣ DOC Status (3 counters in one card) */}
          <div
            className={`overview-doc-group ${
              ["critical", "warning", "healthy"].includes(activeCategory)
                ? "active"
                : ""
            }`}
          >
            <div className="overview-doc-group-title">DOC Status</div>

            <div className="overview-doc-group-items">
              {["critical", "warning", "healthy"].map((key) => (
                <div
                  key={key}
                  className={`overview-doc-mini ${
                    activeCategory === key ? "active" : ""
                  }`}
                  onClick={() => handleCategoryClick(key)}
                  data-category={key}
                  style={{ color: docStats[key].color }}
                >
                  <div className="doc-stat-icon">{docStats[key].icon}</div>

                  <div className="doc-stat-count">
                    {formatNumber(docStats[key].count || 0)}
                  </div>

                  <div className="doc-stat-label">
                    {docStats[key].label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 3️⃣ Overstock */}
          <div
            className={`doc-stat-card ${activeCategory === "overstock" ? "active" : ""}`}
            onClick={() => handleCategoryClick("overstock")}
            style={{ cursor: "pointer", borderLeft: `4px solid ${docStats.overstock.color}` }}
          >
            <div className="doc-stat-icon" style={{ color: docStats.overstock.color }}>
              {docStats.overstock.icon}
            </div>
            <div className="doc-stat-content">
              <div className="doc-stat-count">
                {formatNumber(docStats.overstock.count || 0)}
              </div>
              <div className="doc-stat-label">{docStats.overstock.label}</div>
              <div className="doc-stat-range">{docStats.overstock.range}</div>
              <div className="doc-stat-description">{docStats.overstock.description}</div>
            </div>
          </div>

          {/* 4️⃣ Potential Risk (4 counters) */}
          <div 
            className={`doc-stat-card ${activeCategory === 'potentialRisk' ? 'active' : ''}`}
            onClick={() => handleCategoryClick('potentialRisk')}
            style={{ 
              borderLeft: `4px solid #e83e8c`,
              cursor: 'pointer'
            }}
          >
            <div className="doc-stat-icon" style={{ color: "#e83e8c" }}>
              <FaMoneyBillWave />
            </div>
            {/* ✅ Potential Risk - FULL counter div (all rows) */}
<div className="doc-stat-content">
  <div className="doc-stat-label mb-3">Potential Risk</div>

  {/* Top Row: Risk Qty & GMV at Risk */}
  <div className="counters-row top-row">
    <div className="counter-item">
      <div className="counter-value">
        {hasAnimated ? (
          <span>{formatNumber(getPotentialRiskData().riskQty)}</span>
        ) : (
          <CountUp
            key={`potentialRisk-qty-${Date.now()}`}
            start={0}
            end={getPotentialRiskData().riskQty}
            duration={1}
            formattingFn={formatNumber}
          />
        )}
      </div>
      <div className="counter-label">Risk Qty</div>
    </div>

    <div className="counter-divider"></div>

    <div className="counter-item">
      <div className="counter-value">
        {hasAnimated ? (
          <span>₹{formatNumber(getPotentialRiskData().gmvAtRisk)}</span>
        ) : (
          <CountUp
            key={`potentialRisk-gmv-${Date.now()}`}
            start={0}
            end={getPotentialRiskData().gmvAtRisk}
            duration={1}
            formattingFn={formatNumber}
            prefix="₹"
          />
        )}
      </div>
      <div className="counter-label">GMV at Risk</div>
    </div>
  </div>

  {/* Middle Row: RTO Stock & Non-Inv Stock */}
  <div className="counters-row bottom-row">
    <div className="counter-item">
      <div className="counter-value">
        {hasAnimated ? (
          <span>{formatNumber(getPotentialRiskData().rtoStock)}</span>
        ) : (
          <CountUp
            key={`potentialRisk-rto-${Date.now()}`}
            start={0}
            end={getPotentialRiskData().rtoStock}
            duration={1}
            formattingFn={formatNumber}
          />
        )}
      </div>
      <div className="counter-label">RTO QTY</div>
    </div>

    <div className="counter-divider"></div>


    <div className="counter-item">
      <div className="counter-value">
        {hasAnimated ? (
          <span>₹{formatNumber(getPotentialRiskData().rtoTotalGmv)}</span>
        ) : (
          <CountUp
            key={`potentialRisk-rtosku-${Date.now()}`}
            start={0}
            end={getPotentialRiskData().rtoTotalGmv}
            duration={1}
            formattingFn={formatNumber}
          />
        )}
      </div>
      <div className="counter-label">RTO GMV</div>
    </div>
  </div>

 
</div>

          </div>

          {/* 5️⃣ Non Fresh (4 counters) */}
<div 
  className={`doc-stat-card ${activeCategory === 'nonFresh' ? 'active' : ''}`}
  onClick={() => handleCategoryClick('nonFresh')}
  style={{ 
    borderLeft: `4px solid #ff6b6b`,
    cursor: 'pointer'
  }}
>
  <div className="doc-stat-icon" style={{ color: "#ff6b6b" }}>
    <WiCloudRefresh size={{ width: 3, height: 2 }} />
  </div>
  <div className="doc-stat-content">
    <div className="doc-stat-label">Non Fresh & Non Invoiceable</div>
    
    {/* Top Row: Non Fresh related counters */}
    <div className="counters-row top-row">
      <div className="counter-item">
        <div className="counter-value">
          {hasAnimated ? (
            <span>{formatNumber(getNonFreshData().nonFreshStock)}</span>
          ) : (
            <CountUp 
              key={`nonFresh-stock-${Date.now()}`}
              start={0} 
              end={getNonFreshData().nonFreshStock} 
              duration={1}
              formattingFn={formatNumber}
            />
          )}
        </div>
        <div className="counter-label">Non-Fresh QTY </div>
      </div>
      
      <div className="counter-divider"></div>
      
      <div className="counter-item">
        <div className="counter-value">
          {hasAnimated ? (
            <span>₹{formatNumber(getNonFreshData().nonFreshGmv)}</span>
          ) : (
            <CountUp 
              key={`nonFresh-gmv-${Date.now()}`}
              start={0} 
              end={getNonFreshData().nonFreshGmv} 
              duration={1}
              formattingFn={formatNumber}
            />
          )}
        </div>
        <div className="counter-label">Non-Fresh GMV</div>
      </div>
    </div>
    
    {/* Bottom Row: Non Invoiceable related counters */}
    <div className="counters-row bottom-row">
      <div className="counter-item">
        <div className="counter-value">
          {hasAnimated ? (
            <span>{formatNumber(getNonFreshData().nonInvoiceableStock)}</span>
          ) : (
            <CountUp 
              key={`nonInvoiceable-stock-${Date.now()}`}
              start={0} 
              end={getNonFreshData().nonInvoiceableStock} 
              duration={1}
              formattingFn={formatNumber}
            />
          )}
        </div>
        <div className="counter-label">Non-Invoiceable QTY</div>
      </div>
      
      <div className="counter-divider"></div>
      
      <div className="counter-item">
        <div className="counter-value">
          {hasAnimated ? (
            <span>₹{formatNumber(getNonFreshData().nonInvoiceableGmv)}</span>
          ) : (
            <CountUp 
              key={`nonInvoiceable-gmv-${Date.now()}`}
              start={0} 
              end={getNonFreshData().nonInvoiceableGmv} 
              duration={1}
              formattingFn={formatNumber}
            />
          )}
        </div>
        <div className="counter-label">Non-Invoiceable GMV</div>
      </div>
    </div>
  </div>
</div>
        </div>

        {/* DOC Legend */}
        <div className="doc-legend">
          <div className="legend-item critical">
            <span className="legend-dot" style={{ backgroundColor: "#dc3545" }}></span>
            <span className="legend-text">Critical (0-7 Days DOC) - Immediate action needed</span>
          </div>
          <div className="legend-item warning">
            <span className="legend-dot" style={{ backgroundColor: "#ff9800" }}></span>
            <span className="legend-text">Warning (8-14 Days DOC) - Monitor closely</span>
          </div>
          <div className="legend-item healthy">
            <span className="legend-dot" style={{ backgroundColor: "#28a745" }}></span>
            <span className="legend-text">Healthy (15-60 Days DOC) - No action required</span>
          </div>
          <div className="legend-item overstock">
            <span className="legend-dot" style={{ backgroundColor: "#6f42c1" }}></span>
            <span className="legend-text">Overstock (60 Days DOC) - Potential waste risk</span>
          </div>
        </div>

        {/* Inventory Table */}
        <div className="inventory-table-container">
          <div className="table-header">
            <h3>
              {activeCategory === 'total' ? 'All SKUs' : 
               activeCategory === 'potentialRisk' ? 'Potential Risk Analysis' :
               activeCategory === 'nonFresh' ? 'Non Fresh Analysis' :
               docStats[activeCategory]?.label + ' SKUs'} 
            </h3>
            <div className="table-actions">
              <button className="btn-export" onClick={handleExport}>
                <FaDownload /> Export
              </button>
            </div>
          </div>
          <div className="ag-theme-alpine" style={{ height: 500, width: "100%" }}>
            <AgGridReact
              rowData={rowData}
              columnDefs={columnDefs[activeCategory] || columnDefs.total}
              defaultColDef={defaultColDef}
              onGridReady={onGridReady}
              sideBar={sideBar}
              statusBar={statusPanel}
              enableRangeSelection={true}
              overlayNoRowsTemplate="No inventory data available"
            />
          </div>
        </div>
      </div>

      {/* Loader and overlay */}
      <div className={`loader ${loadshow}`} style={{ zIndex: "1002" }}></div>
      <div className={`overlay-block ${overlayBlock}`}></div>
    </>
  );
};

export default OverviewDashboard;